import { render, staticRenderFns } from "./CompanyOurStory.vue?vue&type=template&id=7e9ada27&scoped=true&"
import script from "./CompanyOurStory.vue?vue&type=script&lang=js&"
export * from "./CompanyOurStory.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOurStory.vue?vue&type=style&index=0&id=7e9ada27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9ada27",
  null
  
)

export default component.exports